import { Components, Theme } from '@mui/material';

export const paperComponentOverrides: Components<Theme>['MuiPaper'] = {
  // TODO Stop restyling MUI components and wrap them in our own components
  styleOverrides: {
    root: () => ({
      boxShadow: 'none',
      '&:hover': {
        boxShadow: 'none',
      },
      '&:active': {
        boxShadow: 'none',
      },
      '&:focus': {
        boxShadow: 'none',
      },
    }),
  },
};
